export default (() => {
  try {
    return window.localStorage;
  } catch (error) {}
})();
